/* global require document */
import Vue from "vue";
import moment from "moment";

import { trans } from "common/translate";
import { openCommentsOverlay } from "pages/explore-the-archive/commentsOverlay.js";

export default Vue.component("discussion", {
  props: [ "data" ],

  data() {
    return {
      trans,
    };
  },

  methods: {
    formatDate( date ) {
      return moment(date).format("MMM D YYYY, H:mm");
    },
    openCommentsOverlay() {
      openCommentsOverlay();
    }
  },

  template: require("./templates/discussion.html"),
});




// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/archive/discussion.js